const getters = {
    token: state => state.user.token,
    name: state => state.user.name,
    userId: state => state.user.userId,
    roleName: state => state.user.roleName,
    roleId:state => state.user.roleId,
    roleCode: state => state.user.roleCode,
    lastLoginDate: state => state.user.lastLoginDate,
    lastLoginTime: state => state.user.lastLoginTime,
    menus: state => state.user.menus,
    isReg: state => state.user.isReg,
    isAleader: state => state.user.isAleader,
    showDept: state => state.user.showDept,
    showHDS: state => state.user.showHDS,
    deptName: state => state.user.deptName,
    routeList: state => state.tool.routeList,
    hasGetRoute: state => state.tool.hasGetRoute
}

export default getters